import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=439fd5f4&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=ts"
export * from "./StockList.vue?vue&type=script&lang=ts"
import style0 from "./StockList.vue?vue&type=style&index=0&id=439fd5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439fd5f4",
  null
  
)

export default component.exports